/**
 * Shipment Management Screen
 * 
 * Main screen component that switches between desktop and mobile versions.
 * 
 * @module ShipmentManagementScreen
 */

import React from 'react';
import { Platform } from '../../components/common';
import { ShipmentManagementScreenDesktop } from './ShipmentManagementScreenDesktop';
import { ShipmentManagementScreenMobile } from './ShipmentManagementScreenMobile';

export const ShipmentManagementScreen: React.FC = () => {
  if (Platform.OS === 'web') {
    return <ShipmentManagementScreenDesktop />;
  }
  return <ShipmentManagementScreenMobile />;
};

